import { createContext, useContext } from 'react'

import { Widget } from 'features/views/LayoutEditor/types'

export type LayoutEditorDnDDragTarget = {
    path: string[]
    idx: number
}

export type LayoutEditorDnDContextValue = {
    activeDragWidget?: Widget
    initialDragTarget?: LayoutEditorDnDDragTarget
    destinationDragTarget?: LayoutEditorDnDDragTarget
}

export const LayoutEditorDnDContext = createContext<LayoutEditorDnDContextValue | null>(null)

export function useLayoutEditorDnDContext(): LayoutEditorDnDContextValue {
    const context = useContext(LayoutEditorDnDContext)
    if (!context) {
        throw new Error(
            'useLayoutEditorDnDContext must be used within a LayoutEditorDnDContextProvider'
        )
    }

    return context
}
